import { makeActionCreator } from '../../util/make_action_creator'

export const SET_APP_STATE = 'SET_APP_STATE'
export const setAppState = makeActionCreator(SET_APP_STATE, 'key', 'value')
